/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import "../Header/index.css";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
export default function Navheader(props) {
  const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if (window.scrollY >= 9) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changebackground);
  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        bg="dark"
        variant="dark"
        className={navbar ? "navbar active" : "navbar"}
      >
        <div className="mb-3 align-center">
          <a
            href="https://www.swmc.com"
            target="_blank"
            rel="noreferrer noopener"
            className="a-link"
          >
            <img
              src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg"
              alt="Sun West Mortgage Logo"
              className="swmclogo img-fluid"
            />
          </a>
        </div>
        <div className="userway-div">
          <Container >
        <UserWayAccessibilityMenu color="white" width={40} height={40} />
        </Container>
        </div>
      </Navbar>
    </>
  );
}
